import bootstrapButtonBase from '../styles/bootstrap/base/button';
import bootstrapCodeBase from '../styles/bootstrap/base/code';
import bootstrapCommonBase from '../styles/bootstrap/base/common';
import bootstrapFormBase from '../styles/bootstrap/base/form';
import bootstrapHeadingsBase from '../styles/bootstrap/base/headings';
import bootstrapLinkBase from '../styles/bootstrap/base/link';
import bootstrapTextBase from '../styles/bootstrap/base/text';
export const buttonBases = { bootstrap: bootstrapButtonBase };
export const codeBases = { bootstrap: bootstrapCodeBase };
export const commonBases = { bootstrap: bootstrapCommonBase };
export const formBases = { bootstrap: bootstrapFormBase };
export const headingsBases = { bootstrap: bootstrapHeadingsBase };
export const linkBases = { bootstrap: bootstrapLinkBase };
export const textBases = { bootstrap: bootstrapTextBase };
//# sourceMappingURL=bases.js.map